import request from '@/utils/request'

// 列表
export function apiInvCallRequestLinesWarehousingList (query) {
  return request({
    url: '/inv/invCallRequestLines/warehousingList',
    method: 'get',
    params: query
  })
}

// 保存
export function apiInvCallRequestLinesWarehousing (data) {
  return request({
    url: '/inv/invCallRequestLines/warehousing',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiInvCallRequestLinesNewExport (data) {
  return request({
    url: '/inv/invCallRequestLines/v2/warehousingListExport',
    method: 'post',
    data: data
  })
}
